import { PROFILE_DETAILS } from "../constants/reduxConstants";

export const profileDetailsAction = (payload) => {
  return {
    type: PROFILE_DETAILS,
    payload,
  };
};
